import { AxiosResponse } from "axios";
import { ServiceResponseData } from "../ServiceResponseData";
import { SoftwareFilter } from "../../data/updates/SoftwareFilter";
import { NamedSoftwareVersion } from "@/model/data/updates/NamedSoftwareVersion";

export class FetchAvailableSoftwareFiltersResponse extends ServiceResponseData {
  availableSoftwareFilter: SoftwareFilter[];

  constructor(response: AxiosResponse) {
    super(response);
    if (response.data && response.data.Payload) {
      const data = response.data.Payload.UpdateTypeResult;

      this.availableSoftwareFilter = [];
      data.forEach((sw) => {
        var existing = this.availableSoftwareFilter.find((c) => c.updateType == sw.UpdateType);
        var vers = new NamedSoftwareVersion(sw.Name, sw.Version);
        if (existing) {
          existing.versionsList.push(vers);
        } else {
          var newSoftwareFilter = new SoftwareFilter(sw.UpdateType);
          newSoftwareFilter.versionsList.push(vers);
          this.availableSoftwareFilter.push(newSoftwareFilter);
        }
      });
    }
  }
}
